<script lang='ts'>
  import type { Storefront, StorefrontFeaturedProduct } from 'app/javascript/shared/javascripts/types/Storefront';
  import { selectAlternatives, orderAlternativesByPreview } from '@distributor/svelte/Storefront/Utils/AlternativesUtils.svelte';
  import Icon from '@shared/svelte/Components/Icon.svelte';
  import { stagedRolloutCheck } from '@shared/svelte/Modules/StagedRolloutCheck.svelte';
  export let storefront : Storefront;
  export let callbacks: any;
  import FeaturedProduct from './FeaturedProduct.svelte';
  import { onMount } from 'svelte';

  function deleteFeatured(alternative:boolean) {
    let index = alternative ? 1 : 0
    let chosenProduct:StorefrontFeaturedProduct = selectAlternatives(storefront, 'featured')[index]
    storefront.storefront_featured_products_attributes = [{
      id: chosenProduct.id,
      _destroy: true
    }];
    callbacks.update(storefront);
  }

  function swapDefaults() {
    let curDefault:StorefrontFeaturedProduct = selectAlternatives(storefront, 'featured')[0]
    let newDefault:StorefrontFeaturedProduct = selectAlternatives(storefront, 'featured')[1]
    let toSend = []
    if (curDefault) {
      toSend.push({
        id: curDefault.id,
        alternative_index: 1,
        preview_alternative_index: 1
      })
    }

    if (newDefault) {
      toSend.push({
        id: newDefault.id,
        alternative_index: 0,
        preview_alternative_index: 0
      })
    }
    callbacks.setLoading(true);
    curTab = 'default';
    storefront.storefront_featured_products_attributes = toSend;
    callbacks.update(storefront);
  }

  function swapPreview(switchingToIndex:number) {
    const otherInd = switchingToIndex == 1 ? 0 : 1
    const alts:StorefrontFeaturedProduct[] = selectAlternatives(storefront, 'featured')
    const toShow:StorefrontFeaturedProduct = alts.find((x) => x.alternative_index === switchingToIndex)
    const toNotShow:StorefrontFeaturedProduct = alts.find((x) => x.alternative_index === otherInd)

    let toSend = []
    if (toShow) {
      toSend.push({
        id: toShow.id,
        preview_alternative_index: 0
      })
    }

    if (toNotShow) {
      toSend.push({
        id: toNotShow.id,
        preview_alternative_index: 1
      })
    }
    storefront.storefront_featured_products_attributes = toSend;
    callbacks.update(storefront);
  }

  const allowAlternatives = stagedRolloutCheck('distributor_storefront_alternatives')
  $: curAlt = selectAlternatives(storefront, 'featured')[1]?.product_line_id

  let curTab = 'default';
  let switchingToIndex:number;
  function switchTo(selection) {
    callbacks.setLoading(true);
    curTab = selection;
    switchingToIndex = (curTab == 'default') ? 0 : 1
    swapPreview(switchingToIndex);
  }

  onMount(function() {
    switchTo(curTab)
  })
</script>

{#if storefront.enable_featured_product}
  {#if allowAlternatives}
    <ul class="fizz-tab-list">
      <li class:fizz-is-active={curTab == 'default'} id='switch-to-default'
        on:click={() => switchTo('default')}>Default</li>
      <li class:fizz-is-active={curTab == 'alternative'} id='switch-to-alternative'
        on:click={() => switchTo('alternative')}>Alternate</li>
    </ul>
  {/if}

  {#if curTab == 'default'}
    <dd id="{'inner_edit_featured_product_featured'}">
      <section id="featured-item" class='fizz-text-small'>
        {#if allowAlternatives}
          <p class="fizz-label fizz-space-between fizz-stack-16">Default
            <Icon
              width="16"
              height="16" onPress={() => deleteFeatured(false)}
              type="Trash" extraClassNames='cursor-pointer'
            ></Icon>
          </p>
        {/if}
        {#if !storefront.loading}
          <FeaturedProduct {storefront} {callbacks} orientation={'featured'}></FeaturedProduct>
        {/if}
      </section>
    </dd>
  {/if}

  {#if curTab == 'alternative'}
    <dd id="{'inner_edit_featured_items_alternative'}">
      <section id="alternative-featured-item" class='fizz-text-small'>
        <p class="fizz-label fizz-space-between fizz-stack-16">Alternative
          {#if curAlt}
            <button class="fizz-button-small" on:click={() => swapDefaults()}>Make Default</button>
            <Icon
              width="16"
              height="16" onPress={() => deleteFeatured(true)}
              type="Trash" extraClassNames='cursor-pointer'
            ></Icon>
          {/if}
        </p>
        {#if !storefront.loading}
          <FeaturedProduct {storefront} {callbacks} orientation={'featured'}
            alternative={true}></FeaturedProduct>
        {/if}
      </section>
    </dd>
  {/if}

{/if}